import { useMemo } from 'react';

import { useAscContext } from '@neo.tax/asc/context';
import { getAscNavSection } from '@neo.tax/asc/utils';
import { SideNavProps, useCurrentCompanyId, useCurrentUserScopeForCurrentCompany } from '@neo.tax/shared';

export const useAscNavSections = (): SideNavProps['sections'] => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId, periodName } = useAscContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();

  return useMemo(
    () =>
      getAscNavSection({
        companyId,
        fiscalYearId,
        isNonFinancialUser: limitAccessToFinancialData,
        periodName,
      }),
    [companyId, fiscalYearId, limitAccessToFinancialData, periodName],
  );
};
